export type IconProps = {
  type: 'material-community'
  name: string
}

export const icons: {
  [key: string]: IconProps
} = {}
